import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Input from './Input';
import Button from '../Button';
import InputGroup from './InputGroup';
import ButtonAlt from '../other-components/Button';

function DataAttributes({ name, value = [], onChange }) {
    const addNewColor = useCallback(() => {
        const modified = value ? [...value] : [];
        modified.push('');
        onChange({ name, value: modified });
    }, [name, value, onChange]);

    const handleChange = useCallback(
        ({ name: index, value: newValue }) => {
            const modified = [...value];
            newValue !== undefined
                ? modified.splice(index, 1, newValue)
                : modified.splice(index, 1);
            onChange({ name, value: modified });
        },
        [name, onChange, value]
    );

    return (
        <>
            {value.map((item, index) => (
                <InputGroup style={{ marginBottom: 10 }}>
                    <Input
                        value={item}
                        name={index}
                        onChange={handleChange}
                        placeholder={`data-example="value"`}
                    />
                    <Button
                        type="danger"
                        onClick={() => handleChange({ name: index })}
                    >
                        <FontAwesomeIcon icon={['far', 'trash-alt']} />
                    </Button>
                </InputGroup>
            ))}
            <ButtonAlt
                size="sm"
                width="100%"
                border="dotted"
                onClick={addNewColor}
            >
                + Add New Data Attribute
            </ButtonAlt>
        </>
    );
}

export default DataAttributes;
